
export default function (state = false, action) {
  return (window.location.search.search(/fabric=1/i) >= 0 || window.location.search.search(/fabric=true/i) >= 0)
}